import { render, staticRenderFns } from "./marketTrade.vue?vue&type=template&id=16c7b610&scoped=true&"
import script from "./marketTrade.vue?vue&type=script&lang=js&"
export * from "./marketTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c7b610",
  null
  
)

export default component.exports